export const API_CONFIG = {
	baseURL:
		(import.meta as any).env?.VITE_API_URL ||
		(typeof window !== "undefined" ? window.location.origin : ""),
	endpoints: {
		options: "/api/options",
		meta: "/api/meta",
		feed: "/api/feed",
		object: "/api/object",
	},
	defaultParams: {
		page: 1,
		limit: 12,
	},
	filters: {
		rooms: null as number | null,
		price_min: null as number | null,
		price_max: null as number | null,
		square_min: null as number | null,
		square_max: null as number | null,
		object_type: "",
		category: "",
		operation_type: "",
	},
}

export const IMAGE_UTILS = {
	getImageUrl(images: Array<{ url: string }> | undefined, fallback = "/placeholder.jpg"): string {
		return images?.[0]?.url || fallback
	},
	handleImageError(event: Event): void {
		const target = event.target as HTMLImageElement
		target.src = "/placeholder.jpg"
	},
}

export interface WordPressObject {
	id: number
	object_id: string
	title: string
	address: string
	description: string
	contact_phone: string
	contact_method: string
	images: Array<{ url: string }>
	category: string
	operation_type: string
	price: number
	rooms: number
	square: number
	floor: number
	floors: number
	house_type: string
	market_type: string
	new_development_id: string
	property_rights: string
	decoration: string
	safe_demonstration: string
	status: string
	object_type: string
}

export interface WordPressFeedResponse {
	objects: WordPressObject[]
	total: number
	count: number
	page: number
	limit: number
	total_pages: number
	filters: Record<string, any>
}
